import './index.scss'

class Text {
    constructor(el) {
        this.$el = el

        // console.log('Text::constructor')
    }
    init() {
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-text') ].forEach($block => {
        $block.expandygg = new Text($block)
    })
}, {capture: false, passive: true, once: true} || false)